import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import ClientAssignForm from '@/components/CommercialPage/ClientAssignForm';
import ClientList from '@/components/CommercialPage/ClientList';
import ClientRegistrationForm from '@/components/CommercialPage/ClientRegistrationForm';
import CommercialLayout from '@/components/CommercialPage/CommercialLayout';
import EmptyView from '@/components/common/EmptyView';
import UserDetails from '@/components/FranchiseeSettingsPage/UserDetails';
import UserForm from '@/components/FranchiseeSettingsPage/UserForm';
import UserList from '@/components/FranchiseeSettingsPage/UserList';
import Section from '@/components/Page/Section';

const CommercialPage = () => (
  <CommercialLayout>
    <Section cols={6}>
      <Routes>
        <Route index element={<Navigate to="clients" replace />} />
        <Route path="clients/*" element={<ClientList />} />
        <Route path="settings" element={<Navigate to="users" replace />} />
        <Route path="settings/users/*" element={<UserList />} />
      </Routes>
    </Section>
    <Section cols={6}>
      <Routes>
        <Route path="clients/new" element={<ClientRegistrationForm />} />
        <Route path="clients/:id" element={<ClientAssignForm />} />
        <Route path="settings/users" element={<EmptyView />} />
        <Route path="settings/users/new" element={<UserForm action="create" />} />
        <Route path="settings/users/:id/edit" element={<UserForm action="edit" />} />
        <Route path="settings/users/:id" element={<UserDetails />} />
      </Routes>
    </Section>
  </CommercialLayout>
);

export default CommercialPage;
